// /contexts/codeContextKiosk.js
import React, { createContext, useContext, useEffect, useState } from "react";
import {collection, getDocs, query, orderBy, onSnapshot } from 'firebase/firestore';
import { kioskDB } from 'utils/firebase';


const CodeContext = createContext();

export const CodeProviderKiosk = ({ children }) => {
  const [codes, setCodes] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInitialCodes = async () => {
      try {
        // 1️⃣ 로컬 캐시 확인
        const cached = localStorage.getItem("generalCodes");
        if (cached) {
          setCodes(JSON.parse(cached));
        }

        // 2️⃣ Firestore에서 최신 데이터 가져오기
        const querySnapshot = await getDocs(collection(kioskDB, "generalCodes"));
        const allCodes = {};

        querySnapshot.forEach((doc) => {
          const data = doc.data();
          const filteredCodes = (data.codes || [])
            .filter(code => code.useYn === true) // ✅ useYn이 true인 것만
            .sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)); // 정렬

          allCodes[doc.id] = {
            codeName: data.codeName,
            codes: filteredCodes
            //codes: (data.codes || []).sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
          };
        });

        setCodes(allCodes);
        localStorage.setItem("generalCodes", JSON.stringify(allCodes));
      } catch (error) {
        console.error("Error fetching initial codes:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchInitialCodes();

    // 3️⃣ Firestore 실시간 구독
    const unsubscribe = onSnapshot(collection(kioskDB, "generalCodes"), (snapshot) => {
      const updatedCodes = {};
      snapshot.forEach((doc) => {
        const data = doc.data();
        const filteredCodes = (data.codes || [])
          .filter(code => code.useYn === true) // ✅ 실시간 구독 시에도 필터링
          .sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0));

        updatedCodes[doc.id] = {
          codeName: data.codeName,
          codes: filteredCodes
          //codes: (data.codes || []).sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
        };
      });

      // 4️⃣ 기존 데이터와 비교 후 updateDt 기준 갱신
      let shouldUpdate = false;
      Object.keys(updatedCodes).forEach((key) => {
        const oldCodes = codes[key]?.codes || [];
        const newCodes = updatedCodes[key].codes;

        const oldLatest = Math.max(...oldCodes.map(c => new Date(c.updateDt).getTime()), 0);
        const newLatest = Math.max(...newCodes.map(c => new Date(c.updateDt).getTime()), 0);

        if (newLatest > oldLatest) {
          shouldUpdate = true;
        }
      });

      if (shouldUpdate) {
        setCodes(updatedCodes);
        localStorage.setItem("generalCodes", JSON.stringify(updatedCodes));
      }
    });

    return () => unsubscribe(); // 구독 해제
  }, []);

  return (
    <CodeContext.Provider value={{ codes, loading }}>
      {children}
    </CodeContext.Provider>
  );
};

export const useCodesKiosk = () => useContext(CodeContext);
